import { createContext } from "react";
import { ILocationsContext } from "./LocationsContextInterfaces";

export const initialState: ILocationsContext = {
    millTimezone: undefined,
    handleMillTimezone: () => {},
};

export const LocationsContext = createContext(initialState);
